import { Tabs, Tab, Box, Typography, styled } from '@mui/material';

export const StyledLabel = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem !important',
  fontWeight: 500,
  lineHeight: 1.4,

  [theme.breakpoints.down('lg')]: {
    fontSize: '1.35rem !important',
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: '1.2rem !important',
  },
}));

export const DetailMenuSection = ({ sectionList, activeKey, onMenuClick }) => {
  const value = sectionList.findIndex((item) => item.key === activeKey);

  return (
    <Box
      sx={{
        bgcolor: '#fff',
        overflow: 'auto',
        whiteSpace: 'nowrap',
      }}
    >
      <Tabs
        value={value}
        onChange={(_, newValue) => onMenuClick(sectionList[newValue].key)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        TabIndicatorProps={{ sx: { display: 'none' } }}
        sx={{
          '.MuiTabs-scrollButtons': { width: 'auto' },
          '.MuiTabs-scrollButtons.Mui-disabled': { display: 'none' },
        }}
      >
        {sectionList.map((item) => (
          <Tab
            key={item.key}
            label={<StyledLabel variant="h2">{item.label}</StyledLabel>}
            sx={{
              minWidth: 120,
              textTransform: 'none',
              transition: 'all 0.2s',
              bgcolor: 'transparent',
              borderRadius: 2,
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};
